import type { UserId, User } from "@gs/core/domain/User/User";
import { createDomainStore } from "../_utils/createDomainStore";

export const [userStore, useUserStore] = createDomainStore<User, UserId>("user");
